import React from 'react';
import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloProvider} from '@apollo/react-hooks';
import {useAuth} from "../auth/Auth";
import {ApolloLink} from "apollo-link";

const AIApolloProvider = props => {
    const {children} = props;
    const auth = useAuth();
    const idToken = auth.getIdToken();
    const defaultLink = new HttpLink({
        uri: process.env.NODE_ENV === 'development' ? 'http://localhost:9090/graphql' : null,
        headers: {
            Authorization: idToken ? `Bearer ${idToken}` : '',
        }
    });

    const kGraphQLLink = new HttpLink({
        uri: process.env.NODE_ENV === 'development' ? 'http://localhost:9090/kgraphql' : '/kgraphql',
        headers: {
            Authorization: idToken ? `Bearer ${idToken}` : '',
        }
    });

    /**
     * Apollo Link allows configuration of link chains.
     * @reference https://www.apollographql.com/docs/react/api/link/introduction
     *
     * Quick tutorial on using Apollo Link to configure a simple link chain.
     * @reference https://hartaniyassir.medium.com/how-to-quickly-setup-multiple-graphql-endpoints-in-apollo-client-and-codegen-react-24bba2e2f941
     */
    const client = new ApolloClient({
        link: ApolloLink.split(
            operation => operation.getContext().clientName === 'kgraphql',
            kGraphQLLink,
            defaultLink
        ),
        cache: new InMemoryCache(),
    });

    return (
        <ApolloProvider client={client}>
            {children}
        </ApolloProvider>
    )
};

export default AIApolloProvider;